// @flow
import React, { Component } from 'react';
import Circles from 'components/common/Loaders/Circles';
import WishTemplate from 'components/wish/WishTemplate';
import type { State } from 'store';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { WishActions, CartActions, BaseActions } from '../../store/actionCreators';
import axios from '../../lib/defaultClient';

type Props = {
  logged: boolean,
  wish: any,
  items: any,
  gradeDiscount: any,
};

class WishTemplateContainer extends Component<Props> {
  state = {
    initLoading: true,
  };

  initialize = async () => {
    this.setState({ initLoading: true });
    try {
      if (this.props.logged) {
        await WishActions.getWish();
      }
      this.setState({ initLoading: false });
    } catch (e) {
      console.log(e);
    }
  };

  componentDidMount() {
    this.initialize();
  }

  // 전체 체크
  allCheckedWish() {
    WishActions.allCheckedWish();
  }

  // 한개 체크
  updateCheckedWish(index) {
    WishActions.updateCheckedWish(index);
  }

  // 수량 변경
  updateItemWish = async (index, itemId, payload) => {
    if (this.props.logged) {
      await WishActions.updateItemWish(index, itemId, {
        quantity: Number(payload.target.value),
      });
    } else {
      await WishActions.updateItemAsNonRegisteredWish({
        index,
        itemId,
        quantity: Number(payload.target.value),
      });
    }
  };

  // 전체상품 삭제
  emptyWish = async () => {
    if (this.props.logged) {
      await WishActions.emptyWish();
    } else {
      await WishActions.emptyAsNonRegisteredWish();
    }
  };

  // 선택상품 삭제
  deleteItemCheckedWish = async () => {
    if (this.props.wish.items.length) {
      for (let index = 0; index < this.props.wish.items.length; index += 1) {
        if (this.props.wish.items[index].checked === true) {
          const itemId = this.props.wish.items[index].id;
          if (this.props.logged) {
            // eslint-disable-next-line no-await-in-loop
            await WishActions.deleteItemWish(index, itemId);
            index -= 1;
          } else {
            WishActions.deleteItemAsNonRegisteredWish({ index, itemId });
          }
        }
      }
    }
  };

  // 단일상품 삭제
  deleteItemWish = async (index, itemId) => {
    if (this.props.logged) {
      await WishActions.deleteItemWish(index, itemId);
    }
  };

  onOffer = () => {
    if (this.props.wish.items.filter(item => item.checked === true).length) {
      this.props.history.push('/offer');
    } else {
      alert('상품을 선택 해주세요.');
    }
  };

  onShopping = () => {
    this.props.history.push('/');
  };

  onOrder = async () => {
    if (this.props.wish.items.filter(item => item.checked === true).length) {
      if (this.props.wish.items.length) {
        for (let index = this.props.wish.items.length - 1; index >= 0; index -= 1) {
          if (this.props.wish.items[index].checked === true) {
            const wishId = this.props.wish.items[index].id;
            const productId = this.props.wish.items[index].product.id;
            const productPriceId = this.props.wish.items[index].product_price.id;
            const indexQuantity = this.props.wish.items[index].quantity;
            // eslint-disable-next-line no-await-in-loop
            await CartActions.addItemCart({
              productId,
              productPriceId,
              quantity: indexQuantity,
            });
          }
        }
        await CartActions.getCart();
        BaseActions.showToast({
          type: 'success',
          message: '장바구니에 담았습니다.',
        });
      }
    } else {
      alert('상품을 선택 해주세요.');
    }
  };

  goProduct = async id => {
    if (!id) return;
    try {
      const result = await axios.get(`/products/url/${id}`);
      this.props.history.push(result.data);
    } catch (e) {
      console.error('goProduct error:', e);
    }
  };

  render() {
    if (this.state.initLoading) return <Circles color="blue" size="medium" text="Loading..." />;

    return (
      <WishTemplate
        wish={this.props.wish}
        items={this.props.wish.items}
        goProduct={this.goProduct}
        allCheckedWish={this.allCheckedWish}
        updateCheckedWish={this.updateCheckedWish}
        updateItemWish={this.updateItemWish}
        emptyWish={this.emptyWish}
        deleteItemCheckedWish={this.deleteItemCheckedWish}
        deleteItemWish={this.deleteItemWish}
        removeSelectedWish={this.deleteItemCheckedWish}
        removeAllWish={this.emptyWish}
        onOffer={this.onOffer}
        onShopping={this.onShopping}
        onOrder={this.onOrder}
        gradeDiscount={this.props.gradeDiscount}
      />
    );
  }
}

export default connect(
  ({ wish, user, pender }: State) => ({
    wish,
    items: wish.items,
    logged: !!user.user,
    loading: pender.pending['wish/GET_WISH'],
    loading1: pender.pending['wish/GET_AS_NON_REGISTERED_WISH'],
    gradeDiscount: (user.user && user.user.grade.value) || 0,
  }),
  () => ({}),
)(withRouter(WishTemplateContainer));



// WEBPACK FOOTER //
// ./src/containers/wish/WishTemplateContainer.js